import { Toaster as Sonner } from "sonner";

export function Toaster() {
  return (
    <Sonner
      position="bottom-center"
      offset={16}
      mobileOffset={{ bottom: 88 }}
      visibleToasts={3}
      closeButton={false}
      toastOptions={{
        classNames: {
          toast: "!rounded-2xl !border-line !shadow-[0_18px_50px_rgb(15_23_42/0.16)] !font-sans !text-sm",
          actionButton: "!rounded-pill !bg-primary !font-semibold",
        },
      }}
    />
  );
}
